import { render } from "./Main.vue?vue&type=template&id=b7c45492"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "@/assets/sass/app.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/src/Hikarusa.Webapp/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__